var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AreYouStillThereModal',{attrs:{"visible":_vm.showModal,"duration":_vm.modalDuration},on:{"stay":_vm.handleStay,"logout":_vm.handleLogout}})}
var staticRenderFns = []

export { render, staticRenderFns }